import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import AutoplayVideoOverlay from '../../components/AutoplayVideoOverlay/AutoplayVideoOverlay';
import useLocalStorage from '../../hooks/useLocalStorage';


function CampaignOverlay(props) {
  const {
    matchParam,
    user,
    shouldBeAuthenticated,
    location: { search },
    history,
    purchaseUrl,
  } = props;

  const [value, setValue] = useLocalStorage(
    'nn_campaign_video_overlay_already_shown'
  );
  const [showOverlay, setShowOverlay] = useState(false);

  const shouldEnableCampaignOverlayCheck =
    user.authenticated === shouldBeAuthenticated && matchParam === search;

  useEffect(
    () => {
      if (shouldEnableCampaignOverlayCheck && !value) {
        setValue(true);
        setShowOverlay(true);
      }
    },
    [value]
  );

  const handleClick = () => {
    history.push(purchaseUrl);
  };

  if (showOverlay) {
    return (
      <AutoplayVideoOverlay
        title="Romi Rain joins Naked News!"
        videoUrl="https://allcdn-lw.xcdnpro.com/crm/nakednews/email/example/romi-rain.mp4"
        onCtaClick={handleClick}
      />
    );
  }

  return null;

}

CampaignOverlay.propTypes = {
  matchParam: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  shouldBeAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  purchaseUrl: PropTypes.string.isRequired,
};

export default CampaignOverlay;
